module.exports = __webpack_public_path__ + "images/home/index/screenshot-browser-1-2e1742e4fabb34e5aba25e20545acc42.png";